import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();
const POLL_MS = 60000;
let timer = null;

const fetchDS = () => {
  inflight = inflight || api.get("/data-source").then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); return cache; }).catch(() => cache || { mode: "simulated", hidden: [] }).finally(() => { inflight = null; });
  return inflight;
};

export function useDataSource() {
  const [d, setD] = useState(cache);
  useEffect(() => {
    listeners.add(setD);
    if (!cache) fetchDS().then(setD);
    if (!timer) timer = setInterval(fetchDS, POLL_MS);
    return () => {
      listeners.delete(setD);
      if (!listeners.size && timer) { clearInterval(timer); timer = null; }
    };
  }, []);
  return d || { mode: "simulated", hidden: [], loading: true };
}

export const visibleSports = (keys, ds) => keys.filter((k) => !(ds?.hidden || []).includes(k));

export const agoLabel = (iso) => {
  if (!iso) return "";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  return s < 60 ? "just now" : s < 3600 ? `${Math.floor(s / 60)} min ago` : `${Math.floor(s / 3600)}h ago`;
};
